import { useState } from 'react';
import MonthSelectorCalendar from 'react-native-month-selector';
import { Ionicons } from '@expo/vector-icons';
import moment from 'moment';
import tw from '../../styles/tailwind';
import { TouchableOpacity } from 'react-native-gesture-handler';
import Text from '../Text';
import Icon from '../IcomoonIcon';
import Modal from '../Modal';


export function MonthSelectorDropdown({ onPress, selectedDate, style={} }){
  const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
  const selectedMonthStr = months[selectedDate.getMonth()]

  return (
    <TouchableOpacity
      style={tw.style(`row justify-between bg-gray-100 px-6 h-12 rounded-lg w-55`, style?.container)}
      onPress={onPress}
    >
      <Text style={tw`text-gray-600 font-500 `}>{selectedMonthStr} {selectedDate.getFullYear()}</Text>

      <Icon name='chevron-right' style={{ transform: [{ rotateZ: '90deg' }], marginRight: 5 }} color={tw.color('gray-800')} />
    </TouchableOpacity>
  )
}


export function MonthSelectorModal({ visible, onRequestClose, ...props}){
  return (
    <Modal onRequestClose={onRequestClose} style={{ modal: tw`w-80%` }}>
      <MonthSelector {...props} />
    </Modal>
  )
}

export function MonthSelector({ onChange, selectedDate, maxDate }){
  const [selectedMonth, setSelectedMonth] = useState(selectedDate ?? new Date());
  const momentDate = moment(selectedMonth)
  const monthsShort = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"]

  return (
    <MonthSelectorCalendar
      selectedDate={momentDate}
      nextText={"Sig."}
      nextIcon={<Ionicons name='chevron-forward-circle-outline' size={24} color={"#888"} />}
      prevIcon={<Ionicons name='chevron-back-circle-outline' size={24} color={"#888"} />}
      prevText={"Prev."}
      swipable={true}
      maxDate={maxDate}
      yearTextStyle={tw`font-bold text-lg`}
      currentMonthTextStyle={tw`text-primary`}
      localeSettings={{
        monthsShort: monthsShort,
      }}
      onMonthTapped={(date) => {
        const _date = new Date(date)
        
        setSelectedMonth(_date)
        onChange(_date)
      }}
    />
  )
}